const Heart = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3528 4.01999C19.9765 4.01999 17.874 5.16951 16.4853 6.94877C15.0967 5.16951 12.9942 4.01999 10.6179 4.01999C6.35422 4.01999 3 7.69846 3 12.0966C3 12.7164 3.07823 13.3061 3.1858 13.8459C3.1858 13.9059 3.19558 13.9559 3.21514 14.0058C3.3716 14.7055 3.61608 15.3653 3.93879 15.985C5.46432 19.5135 8.01666 22.3324 10.1387 24.2416C11.2144 25.2112 12.1923 25.9608 12.9062 26.4706C13.268 26.7305 13.5614 26.9204 13.7668 27.0604C13.8743 27.1304 13.9526 27.1803 14.0112 27.2103L14.0797 27.2503C14.7447 27.6901 15.5661 28 16.4658 28C17.3654 28 18.1869 27.7101 18.8616 27.2503L18.9203 27.2103C18.979 27.1703 19.0572 27.1204 19.1648 27.0604C19.3702 26.9304 19.6635 26.7305 20.0254 26.4706C20.7392 25.9608 21.7269 25.2112 22.7928 24.2416C24.9149 22.3324 27.4672 19.5135 28.9928 15.995C29.3155 15.3753 29.5502 14.7155 29.7164 14.0158C29.7262 13.9658 29.736 13.9159 29.7457 13.8759C29.8435 13.4261 29.9022 12.9763 29.9218 12.5264C29.9707 12.3865 30 12.2366 30 12.0766C30 7.65848 26.6458 4 22.3821 4L22.3528 4.01999ZM26.3133 12.0566C25.9319 12.0566 25.6288 11.7468 25.6288 11.3569C25.6288 9.65764 24.2792 8.27822 22.6168 8.27822C22.2354 8.27822 21.9323 7.96835 21.9323 7.57851C21.9323 7.18867 22.2354 6.8788 22.6168 6.8788C25.0322 6.8788 26.9978 8.88796 26.9978 11.3569C26.9978 11.7468 26.6947 12.0566 26.3133 12.0566Z"
        fill="#EB3F3F"
      />
    </svg>
  );
};

export default Heart;
